import { loggerError, loggerInfo } from '@/modules/logger';

import { LogModule } from '@/data/config';
import { ArLang, langConfig, LangKeys } from '@/data/lang';

/**
 * 配置语言
 * 语言数组，目前拆分成简体，繁体，英文和阿拉伯语
 * 后续如果新增语言，通过调用该方法来适配语言
 * @param {Array} LangKeys
 */
export const setLangConfig = (arr: string[]) => {
  const keys = Object.keys(langConfig);

  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];
    if (keys.includes(item)) {
      continue;
    }

    // 需要配置阿拉伯语言
    if (LangKeys.arSA === item) {
      langConfig[item] = ArLang;
    }
  }
};

function formatOnlyFirst(isOnly: boolean, text: string) {
  if (isOnly) {
    return `(${text})?`;
  }
  return text;
}

/**
 * 严格匹配前后
 * @param {boolean} options[isStrictStart] 匹配前面
 * @param {boolean} options[isStrictEnd] 匹配后面
 * @param text
 * @returns
 */
function formatStrict(
  options: {
    isStrictStart?: boolean;
    isStrictEnd?: boolean;
    start?: string;
    end?: string;
  },
  text: string
) {
  const _start = options?.start ?? (options.isStrictStart ? '^' : '');
  const _end = options?.end ?? (options.isStrictEnd ? '$' : '');
  return `${_start}${text}${_end}`;
}

/**
 * @param arr 语言配置
 * @return
 */
export function formatLangItem(arr: string[]) {
  if (!arr.length) {
    loggerError('获取语言数组失败 formatLangItem', LogModule.Lang);
    return '';
  }
  // 判断是否包含前缀
  let isOnlyFirst = false;
  const item = arr.reduce(
    (pre: string[][], item: string) => {
      const [firstArr, secondArr] = pre;
      const _item = item.split('-');

      // 语言数组是否包含有前缀
      // 阿拉伯语，包含Ar
      if (!isOnlyFirst && _item[0] === item) {
        isOnlyFirst = true;
      }

      // 设置语言前缀
      !firstArr.includes(_item[0]) && firstArr.push(_item[0]);

      // 设置语言后缀
      _item.length > 1 && !secondArr.includes(_item[1]) && secondArr.push(_item[1]);

      return [firstArr, secondArr];
    },
    [[], []]
  );

  const [firstArr, secondArr] = item;
  if (!firstArr.length) {
    loggerError('获取语言转化失败 formatLangItem', LogModule.Lang);
    return '';
  }

  return `${firstArr.join('|')}${
    secondArr.length ? formatOnlyFirst(isOnlyFirst, `[-|_](${secondArr.join('|')})`) : ''
  }`;
}

/**
 * 将语言类型格式化成正则表达式
 */
export function formatLangRegx(options?: {
  isStrictStart?: boolean;
  isStrictEnd?: boolean;
  langConfig?: string[];
  isOrigin?: boolean;
  start?: string;
  end?: string;
}): any {
  const _options = {
    isStrictStart: true,
    isStrictEnd: true,
    isOrigin: false,
    ...options,
  };

  const keys = options?.langConfig ? options?.langConfig : Object.keys(langConfig);

  const _lang = keys.reduce((pre: string[], key) => {
    const _item = formatLangItem(langConfig[key]);
    pre.push(`${_item}`);
    return pre;
  }, []);

  if (_options.isOrigin) return _lang;

  const _regx = new RegExp(
    formatStrict(
      {
        isStrictStart: _options.isStrictStart,
        isStrictEnd: _options.isStrictEnd,
        start: _options.start,
        end: _options.end,
      },
      `(${_lang.join('|')})`
    ),
    'i'
  );
  loggerInfo('语言判断的正则表达式: ' + _regx, LogModule.Lang);
  return _regx;
}
